$(document).ready(function () {

    let skip_variant_change = false;

    $('.product-variant-id').on('change', function () {
        if (!skip_variant_change) {
            $('.prod-thumbnail-slider .slideBox[data-variant_id="' + $(this).val() + '"]').closest('.slick-slide').trigger('click');
        }
    }).trigger('change');

    $(".prod_big_slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        swipeToSlide: true,
        adaptiveHeight: true,
        asNavFor: '.prod-thumbnail-slider'
    });

    $(".prod-thumbnail-slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: true,
        asNavFor: '.prod_big_slider',
        swipeToSlide: true,
        dots: false,
        arrows: true,
        focusOnSelect: true,
        verticalSwiping: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    verticalSwiping: false,
                    vertical: false,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    verticalSwiping: false,
                    vertical: false,
                }
            },
        ]
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        let $slide = $(this).find('.slick-slide[data-slick-index=' + nextSlide + ']').find('.slideBox');

        let all_options = $slide.closest('.prod-thumbnail-slider').data('options');
        let value_options = $slide.data('options_value');

        if ($.isArray(all_options) && all_options.length && $.isArray(value_options) && value_options.length) {
            all_options.forEach(function (option, index) {
                $('[name="options[' + option + ']"]').val(value_options[index]);
            });

            skip_variant_change = true;
            document.getElementsByName('options[' + all_options[0] + ']')[0].dispatchEvent(new Event('change', {bubbles: true}));
            skip_variant_change = false;
        }

        document.querySelectorAll('video').forEach((video) => video.pause());
        if((video = $('.prod_big_slider .slick-slide[data-slick-index=' + nextSlide + '] video')).length) {
            console.log(video);
            video[0].play();
        }
    });

    function init_related_slick() {
        $(".related-prod-js > ul").slick({
            dots: false,
            infinite: true,
            arrows: true,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                }

            ],
        });
    }

    $(document).on('init-related-slick', init_related_slick);
});

function increaseValue(ele) {
    console.log(ele.parent().find('input[type="number"]').val());
    var value = ele.parent().find('input[type="number"]').val();
    // var value = parseInt(inputele.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    ele.parent().find('input[type="number"]').val(value);
    if (value == 0) {
        ele.parents('.roomlistbox').removeClass('selectedinput');
        if ($('.quantity').length > 0) {
            ele.parents('.quantity').parent().prev().parent().removeClass('selectedinput');
        }
    } else {
        ele.parents('.roomlistbox').addClass('selectedinput');
        if ($('.quantity').length > 0) {
            ele.parents('.quantity').parent().prev().parent().addClass('selectedinput');
        }
    }
}

function decreaseValue(ele) {
    var value = ele.parent().find('input[type="number"]').val();
    //    var value = parseInt(inputele.value, 10);
    value = isNaN(value) ? 0 : value;
    value < 1 ? value = 1 : '';
    value--;
    ele.parent().find('input[type="number"]').val(value);
    if (value == 0) {
        ele.parents('.roomlistbox').removeClass('selectedinput');
        if ($('.quantity').length > 0) {
            ele.parents('.quantity').parent().prev().parent().removeClass('selectedinput');
        }
    } else {
        ele.parents('.roomlistbox').addClass('selectedinput');
        if ($('.quantity').length > 0) {
            ele.parents('.quantity').parent().prev().parent().addClass('selectedinput');
        }
    }
}
